<script lang="ts"></script>

<template>
	<RouterView />
</template>
